import stringify from "./stringify";
import { pluralize } from 'skypager-util/lib/string'
import mapKeys from 'lodash/mapKeys'
import mapValues from 'lodash/mapValues'
import reduce from 'lodash/reduce'
import isUndefined from 'lodash/isUndefined'
import defaults from 'lodash/defaults'

export function api(options = {}) {
  let { history = this.configHistory, scope = this, baseConfig = {}, features = {}, reducers = {}, keyFn = pluralize } = options

  features = mapValues(features, (fn) => fn.bind(scope))
  reducers = mapValues(reducers, (fn) => fn.bind(scope))
  
  const getState = () => {
    const initialState = reduce(features, (acc, feature, name) => {
      const defaultValue = feature();

      if (isUndefined(defaultValue)) {
        return acc;
      }

      return {
        ...acc,
        [name]: defaultValue,
      };
    }, {});

    const state = history.reduce((acc, { name, args }) => {
      const featureState = acc[name];
      const feature = features[name];

      return {
        ...acc,
        [name]: feature(featureState, ...args),
      };
    }, initialState);

    Object.defineProperty(state, "toString", {
      value: () => stringify(state),
    });

    return state;
  };

  const getConfig = (tap = options.tap) => {
    const state = getState();

    let config = reduce(reducers, (config, reducer, name) => {
      const reduced = reducer(state);
      if (isUndefined(reduced)) {
        return config;
      }

      return {
        ...config,
        [name]: reduced 
      };
    }, Object.assign({}, baseConfig));

    if (typeof tap === 'function') {
      config = tap.call(scope, config, options)
    }

    Object.defineProperty(config, "toString", {
      value: () => stringify(config),
    });

    return config;
  };

  const when = (env, configure) => {
    const envs = Array.isArray(env) ? env : [env];
    const { NODE_ENV = "development" } = process.env;

    if (env === true || envs.indexOf(NODE_ENV) !== -1) {
      return configure(api({features,reducers,history}));
    } else if (typeof env === 'function' && env(getState(), getConfig)) {
      return configure({features, reducers, history})
    }

    return api({features, reducers, history});
  };

  return reduce(features, (acc, feature, name) => ({
    ...acc,
    [name]: (...args) => api({
      features,
      reducers,
      history: history.concat({ args, name }),
    }),
  }), {
    getConfig: (...args) => defaults(mapKeys(getConfig(...args),(v,k) => keyFn(k)), baseConfig),
    getState,
    history,
    when,
  });
}

export default api



// WEBPACK FOOTER //
// ./src/config/index.js